import React from 'react';
import PropTypes from 'prop-types';
import { useHits, useInstantSearch } from 'react-instantsearch';
import CategoryHit from '../../../components/results/products/CategoryHit';
import ProductHit from '../../../components/results/products/ProductHit';

export default function Hits({ additionalData }) {
  const { hits } = useHits();
  const { results } = useInstantSearch();

  // eslint-disable-next-line no-underscore-dangle
  const isLoading = results.__isArtificial;
  const noResults = !isLoading && results.nbHits === 0;

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (noResults) {
    return <div>No results found</div>;
  }

  return (
    <>
      {hits.map((hit) => {
        if (hit.type?.handle === 'productCategory') {
          return (
            <CategoryHit
              key={hit.objectID}
              hit={hit}
              additionalData={additionalData}
            />
          );
        }

        return (
          <ProductHit
            key={hit.objectID}
            hit={hit}
            additionalData={additionalData}
          />
        );
      })}
    </>
  );
}

Hits.propTypes = {
  additionalData: PropTypes.objectOf(PropTypes.any),
};
